// users.state.ts
export interface IUsersState {
   users: any[];
   selectedUser: any;
}

export const initialUsersState: IUsersState = {
   users: [],
   selectedUser: null
};